import React from 'react';

const BriefSection = ({ heading, title, content, className = '' }) => {
  return (
    <section className={`brief-section fade-in ${className}`}>
      <div className="brief-section-heading">
        <p className="text-animation">{heading}</p>
      </div>
      <div className="brief-section-text">
        <div className="brief-section-title">
          <p>{title}</p>
        </div>
        <div className="brief-section-content">
          {content.map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BriefSection;